var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5833 0.75C11.7141 0.75 5.33325 7.13083 5.33325 15H0.583252L6.91659 21.3175L13.2499 15H8.49992C8.49992 8.8725 13.4558 3.91667 19.5833 3.91667C25.7108 3.91667 30.6666 8.8725 30.6666 15C30.6666 21.1275 25.7108 26.0833 19.5833 26.0833C16.5274 26.0833 13.7566 24.8325 11.7616 22.8217L9.51325 25.07C12.0941 27.6508 15.6408 29.25 19.5833 29.25C27.4524 29.25 33.8333 22.8692 33.8333 15C33.8333 7.13083 27.4524 0.75 19.5833 0.75ZM17.9999 8.66667V16.5833L24.7291 20.5733L25.9483 18.5467L20.3749 15.2375V8.66667H17.9999Z",
    fill: "#F47E21"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.1691f57e.svg";
export { ForwardRef as ReactComponent };